// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"option-card_cardContainer__DO00S","cardImage":"option-card_cardImage__OZXhJ","cardTitle":"option-card_cardTitle__U_71A","selected":"option-card_selected__O0k_J"};